import React from 'react';
import HomeScreen from './HomeScreen';

class Home extends React.Component {
    render() {
        return (
            <div>
                <HomeScreen />
            </div>
        )
    }
}

export default Home;